import urlResolver from 'admin/utils/URLResolver';
import useSWR from 'swr';
import { getter } from 'core/utils/request';

const progressGetter = async (url) => {
  const data = await getter(url);

  if (!data) {
    return data;
  }

  const lessons =
    data.lessons.reduce((accumulator, lesson) => {
      accumulator[`${lesson.lesson_id}`] = lesson;
      return accumulator;
    }, {}) || {};
  const exams =
    data.sittings.reduce((accumulator, sitting) => {
      accumulator[`${sitting.exam}`] = sitting;
      return accumulator;
    }, {}) || {};

  const lockedExamIds = data.locked_exam_ids.map(String) || [];

  return {
    video_count: data.video_count || 0,
    videos_watched: data.videos_watched || 0,
    lessons,
    lessons_with_notes_taken: data.lessons_with_notes_taken || [],
    exams,
    locked_exam_ids: lockedExamIds,
  };
};

export const useUserCourseProgress = (userId, classId) => {
  const url = urlResolver.reverse('api:user-progress-course', {
    userId,
    classId,
  });
  const { data, error, mutate } = useSWR(url, progressGetter);

  return {
    data,
    error,
    loading: !data && !error,
    mutate,
  };
};
